<template>
	<div class="mt-70">
		<app-header></app-header>
        <v-container grid-list-xl mt-2 pa-5>
            <V-layout row wrap justify-center align-center mb-0>
                <v-flex lg12 sm12 xs12 md12 class="text-xs-center">
                    <!-- <v-card flat class="mx-5"> -->
                                <div class="font-24">Decades of Financial Expertise</div>
                                <div class="font-14 mt-2">Real solutions to today's real problems</div>
                    <!-- </v-card> -->
                </v-flex>
                <v-flex xs12 mt-5 mb-5>
                    <v-container pa-0 grid-list-xl fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2">                                          
                                    <v-card-title class="font-24 primary--text"><a href="https://iobots.pro" target="_blank" class="pointer">ioBots</a></v-card-title>
                                    <v-card-text>ioBots are professional-grade cryptocurrency trading systems with portfolio risk management and trading strategies aimed at the post-Millennial and Generation Z traders:</v-card-text>
                                    <v-card-text>
                                        Commission- and fee-free; a mobile- and anywhere-platform. 
                                    </v-card-text>
                                    <v-card-text>
                                        The most comprehensive trading system on the market that helps its users to stay in the game for a long time.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2">                                          
                                    <v-card-title class="font-24 primary--text"><a href="https://beta.poet.best" target="_blank" class="pointer">PoET</a></v-card-title>
                                    <v-card-text>Proof of Enquiries & Trades (PoET) is a DLT solution that records every order enquiry ever sent – whether filled or not – and every trade ever executed on a distributed ledger. It makes regulatory compliance and enforcement easy and cost-effective.</v-card-text>
                                    <v-card-text>Trader Credit Score (TCS) is a product that helps licensed firms and their traders streamline their compliance requirements.</v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2">                                          
                                    <v-card-title class="font-24 primary--text"><a :href="domainName" class="pointer">SiP</a></v-card-title>
                                    <v-card-text>The crowd wisdom helps identify financial market manipulations and fake news;</v-card-text>
                                    <v-card-text>A social network rewards good contents.</v-card-text>
                                    <v-card-text>Helps build a loyal and active community.</v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md12 mt-5 class="text-lg-right">
                                <div>
                                    <a :href="domainName">
                                        <v-icon color="grey" size="20" >arrow_back</v-icon>	
                                    </a>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </V-layout>
        </v-container>

	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                domainName: config.ip
                
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {
            


        },
    }
</script>


// WEBPACK FOOTER //
// About.vue?1530f54e